import { useState } from 'react'
        import { useMutation } from '@tanstack/react-query'
        import { ReservationService } from '../../../../../fleet-management/api/reservation-service'

        export function useSearchBar() {
          const [searchQuery, setSearchQuery] = useState('')
          const [searchResults, setSearchResults] = useState([])

          const searchReservation = useMutation({
            mutationFn: async (searchQuery: string) =>
              ReservationService.getReservations({
                pageState: '0',
                pageSize: searchQuery.length > 1 ? 1 : 0,
                programId: 'all',
                query: searchQuery,
                clientId: 'default-client-id', // Replace with actual clientId
              }),
              onSuccess(data) {
                const searchResults = [...data.reservationsList].map((listing) => {
                  return {
                    ...listing,
                    label: getVehicleLabel(listing),
                  }
                })
                setSearchResults(searchResults)
              },
            }
          )

          function resetSearch() {
            setSearchResults([])
            setSearchQuery('')
          }

          return {
            searchQuery,
            setSearchQuery,
            isLoading: searchReservation.isPending,
            searchReservation,
            searchResults,
            resetSearch,
          }
        }

        export function getVehicleLabel(listing) {
          const { year, make, model, vin, accountNumber } = listing
          return `${year} ${make} ${model} ${vin} ${accountNumber}`
        }
